import React, { useState, useEffect } from 'react';
import { Container, Card } from 'react-bootstrap';
import DetalleCasos from './detalle-casos';
import CargarArchivo from './cargar-archivo';
import { LoadingComponent } from 'recupero-comunes';
import { useDispatch, useSelector } from 'react-redux';
import { getInfoCargaAnalyticPrevio } from '../../store/actions/carga-casos-analytic-action';

const CargaAnalytic = () => {
  const [data, setData] = useState([])
  const [loading, setLoading]=useState(false)  
  const dispatch = useDispatch()
  
  const infoCargaAnalyticPrevio = useSelector((state) => state.cargaCasosAnalyticReducer.infoCargaAnalyticPrevio);
  
  useEffect(() => {    
    if (infoCargaAnalyticPrevio!=undefined) {      
      setData(infoCargaAnalyticPrevio.object)
    }
  }, [infoCargaAnalyticPrevio])

  useEffect(() => {
    setLoading(true)        
    dispatch(getInfoCargaAnalyticPrevio())
    .then(()=>setLoading(false))    
  }, [dispatch])

  return (
    <div>            
    <LoadingComponent show={loading}/>
    <Container>
      <Card className='mt-4'>
        <Card.Body>
          <CargarArchivo />
          <DetalleCasos data={data} />
        </Card.Body>
      </Card>
    </Container>
    /</div>
  )
}

export default CargaAnalytic
